import React from 'react';
export function SocialElement(props) {
    const { href, src, alt, cssClass, iconSize, padding } = props;
    const iconSizeNumber = parseInt(iconSize, 10);
    return (React.createElement("table", { align: "center", border: "0", cellPadding: "0", cellSpacing: "0", role: "presentation", style: { float: 'none', display: 'inline-table' } },
        React.createElement("tbody", null,
            React.createElement("tr", { className: cssClass },
                React.createElement("td", { style: {
                        padding,
                        verticalAlign: 'middle',
                    } },
                    React.createElement("table", { border: "0", cellPadding: "0", cellSpacing: "0", role: "presentation", style: { borderRadius: '3px', width: iconSize } },
                        React.createElement("tbody", null,
                            React.createElement("tr", null,
                                React.createElement("td", { style: {
                                        fontSize: '0',
                                        height: iconSize,
                                        verticalAlign: 'middle',
                                        width: iconSize,
                                    } },
                                    React.createElement("a", { href: href, target: "_blank" },
                                        React.createElement("img", { alt: alt, height: iconSizeNumber, src: src, style: { borderRadius: '3px', display: 'block' }, width: iconSizeNumber })))))))))));
}
//# sourceMappingURL=social-element.js.map